export enum OfficeStatus {
  Inactive = 0,
  Active,
}
